import React, { Component } from 'react'

export default class IconMagnifier extends Component {
    render() {
        return (
            <svg className={this.props.className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={this.props.onClick} color="#999999">
                <path className="fill-current" d="M7.75 14.75C9.3031 14.7497 10.8115 14.2298 12.0349 13.273L15.8814 17.1195L17.1186 15.8822L13.2721 12.0357C14.2294 10.8122 14.7496 9.30351 14.75 7.75C14.75 3.89037 11.6096 0.75 7.75 0.75C3.89038 0.75 0.75 3.89037 0.75 7.75C0.75 11.6096 3.89038 14.75 7.75 14.75ZM7.75 2.5C10.6454 2.5 13 4.85462 13 7.75C13 10.6454 10.6454 13 7.75 13C4.85462 13 2.5 10.6454 2.5 7.75C2.5 4.85462 4.85462 2.5 7.75 2.5Z"/>
            </svg>
        )
    }
}
